import { frontendURL } from '../../../helper/URLHelper';
import AiStudioPage from '../../../components-next/ai-studio/AiStudioPage.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/ai-studio'),
      name: 'ai_studio_index',
      meta: { permissions: ['administrator', 'agent', 'custom_role'] },
      component: AiStudioPage,
    },
  ],
};
